export default __webpack_public_path__ + "static/media/banner-hero.0e7716ba.png";